




















































































































import { Component, Vue } from 'vue-property-decorator';
import { CompanyDetailsModule } from '@/store/modules/companyDetails';
import CompanyGeneralDetailsEdit from '@/components/Companies/CompanyGeneralDetailsEdit.vue';
import CompanyBrandDetailsEdit from '@/components/Companies/CompanyProfileDetailsEdit.vue';
import CompanyAccountingDetailsEdit from '@/components/Companies/CompanyAccountingDetailsEdit.vue';
import GiganautVue from '@/components/Shared/GiganautVue';


@Component({
  name: 'CompanyDetails',
  components: { CompanyGeneralDetailsEdit, CompanyBrandDetailsEdit, CompanyAccountingDetailsEdit },
})
export default class extends GiganautVue {

    get currentCompany() {
    return CompanyDetailsModule.currentCompany;
    }

//     get currentCompanyFullAddressLine () {
//     return [CompanyModule.currentCompany.address.buildingNameNumber, 
//             CompanyModule.currentCompany.address.streetRoadBlock, 
//             CompanyModule.currentCompany.address.cityTown, 
//             CompanyModule.currentCompany.address.stateProvinceRegion, 
//             CompanyModule.currentCompany.address.postZipCode]
//             .filter(Boolean).join(", ");
//   }
}
